<template>
  <div class="plan-edit">
    <BaseFrame
     :btns="btns"
      :breadcrumb="[
        {
          name: 'plan',
          title: '采购计划列表'
        },
        {
          name: 'planEdit',
          title: '编辑采购计划'
        }
      ]"
      @btn-click="onBtnClick"
      :loadZIndex = true
    >
      <div slot="ctrls">
        <lk-checkbox
          class="isScan"
          v-model="isScan"
          :true-value="1"
          :false-value="2"
          @on-change="handleChangeScan">扫码添加商品
        </lk-checkbox>
      </div>
      <div slot="info">
        <div class="info-container">
          <div class="info-item">
            <h4>采购计划单号：{{purchasePlan.code}}</h4>
            <div>商品类型：{{purchasePlan.goodsTypeName}}</div>
            <div>来源：{{purchasePlan.typeName}}</div>
            <div>采购人：{{purchasePlan.createUserName}}</div>
            <div>创建时间：{{purchasePlan.createTime}}</div>
          </div>
        </div>
      </div>
      <div slot="content">

        <lk-card title="采购信息">
          <lk-form :label-width='134' label-position="right"
            :model='purchasePlan'
            :rules="planValidate">
            <lk-row>
              <lk-col span='7'>
                <lk-form-item label='商品类型:' prop='goodsType'>
                  <lk-select v-model='purchasePlan.goodsType'  :disabled="editGoodsTypeDisabled" @on-change="onGoodsTypeChange" >
                    <lk-option v-for="item in getNormalGoodsTypes" :key="item.value" :value="item.value">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span='7'>
                <lk-form-item label='来源:' prop='type'>
                  <lk-select v-model='purchasePlan.type' :disabled="originDisabled" @on-change="onGoodsOriginChange">
                    <lk-option v-for="item in getGoodsOrigin" :key="item.value" :value="item.value">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span='10' v-if="expressStatus">
                <lk-form-item label='物流类型:'>
                  <lk-radio-group v-model='purchasePlan.expressType'>
                    <lk-radio v-for='item in expressTypeList1' :key='item.id' :label='item.id' :disabled="editGoodsTypeDisabled">
                      <span>{{item.name}}</span>
                    </lk-radio>
                  </lk-radio-group>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <lk-col span='7'>
                <lk-form-item label='采购形式:' prop='procurementForm'>
                  <lk-select v-model='purchasePlan.procurementForm' :disabled="editGoodsTypeDisabled">
                    <lk-option v-for="item in procurementFormList" :key="item.id" :value="item.id" :disabled="editGoodsTypeDisabled">
                      {{item.name}}
                    </lk-option>
                  </lk-select>
                </lk-form-item>
              </lk-col>
              <lk-col span='7'>
                <lk-form-item label='审批单附件:' prop=''>
                  <Attachment
                    :uploadInfo='uploadInfo'
                    @attachmentConfirm='attachmentConfirm'
                  ></Attachment>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card title="商品信息" class="goods-card">
          <!-- <lk-button type="primary" @click="onShowSearch">新增商品</lk-button> -->
          <div class="goods-add-wrap">
            <label>新增商品：</label>
            <PlanInputSearch ref="goods0"
              :goodsType="purchasePlan.goodsType"
              :selectedList="selectedIdList"
              :isScan="isScan"
              @selected="onInputSelected">
            </PlanInputSearch>
          </div>
          <div class="sum-wrap">
            <div class="title-amount">总商品数量</div>
            <div class="content-amount">{{goodsNum}}</div>
            <div class="title-money">总金额（元）</div>
            <div class="content-money">&yen;{{purchaseAmount}}</div>
          </div>
          <dtp-table border :columns="columns" :data="tableData" class="plan-table"/>
        </lk-card>
        <lk-card title="有效期过期商品" class="expir-card">
          <dtp-table border :columns="expirColumns" :data="expirTable" class="plan-table"/>
        </lk-card>
      </div>
    </BaseFrame>
    <DTPModal
      v-model="typeModelShow"
      :content='typeModalContent'
      @confirm='onTypeModelOk'
      @handleCancel='onTypeModelCancel'
    ></DTPModal>
    <DTPModal
      v-model="resetModelShow"
      content='重置后将清除当前页面所编辑过的的信息'
      @confirm='onResetModelOk'
    ></DTPModal>
    <operate-log v-model="logShow" :logList="LogItems"/>
  </div>
</template>

<script>

import _ from 'lodash';
import { mapGetters } from 'vuex';
import hotkeys from 'hotkeys-js';
import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import OperateLog from '../../components/operateLog';
import DtpTable from '../../components/DtpTable';
import DtpInputNumber from '../../components/DtpInputNumber';
import DTPModal from '../../components/DTPModal.vue';
import PlanInputSearch from './PlanInputSearch.vue';
import Expire from '../../assets/expir.svg';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import expressTypeList from '../../libs/sharedDara';
import Attachment from '../../components/purchase/Attachment';


export default {
  name: 'planInfo',
  components: {
    BaseFrame,
    DtpTable,
    OperateLog,
    DTPModal,
    PlanInputSearch,
    Attachment,
  },
  computed: {
    btns() {
      if (this.purchasePlan.status === 4) {
        return [
          {
            name: 'log',
            text: '操作日志',
          },
          {
            name: 'cancel',
            text: '取消',
          },
          {
            name: 'reset',
            text: '重置',
          },
          {
            name: 'submit',
            text: '提交',
            type: 'primary',
          },
        ];
      }
      return [
        {
          name: 'log',
          text: '操作日志',
        },
        {
          name: 'cancel',
          text: '取消',
        },
        {
          name: 'reset',
          text: '重置',
        },
        {
          name: 'save',
          text: '保存',
        },
        {
          name: 'submit',
          text: '提交',
          type: 'primary',
        },
      ];
    },
    editGoodsTypeDisabled() {
      if (this.purchasePlan.status === 1) {
        return false;
      }
      return true;
    },
    originDisabled() {
      if (this.purchasePlan.status !== 1) {
        return true;
      } if (this.purchasePlan.goodsType === 3) {
        return true;
      }
      return false;
    },
    selectedIdList() {
      return this.tableData.map(item => item.purchaseMedicineMedicineId);
    },
    ...mapGetters(['getGoodsOrigin']),
    expirTable() {
      return this.tableData.filter(value => value.purchaseMedicineHasExpiryLicense == 1);
    },
    goodsNum() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += item.purchaseMedicineNum;
      });
      return res.toFixed(2);
    },
    purchaseAmount() {
      let res = 0;
      this.tableData.forEach((item) => {
        res += (item.purchaseMedicineNum * item.purchaseMedicinePlanPrice);
      });
      return res.toFixed(2);
    },
  },
  data() {
    return {
      uploadInfo: [], // 附件
      limitedNumer: 100,
      expressStatus: true,
      expressTypeList1: [],
      procurementFormList: [],
      getNormalGoodsTypes: [],
      isScan: 2,
      typeModalContent: '',
      LogItems: [],
      logShow: false,
      typeModelShow: false,
      resetModelShow: false,
      queryParams: {
        purchasePlanId: '',
      },
      backGoodsType: 1,
      backOriginType: 1,
      planValidate: {
        goodsType: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          },
        ],
        type: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          },
        ],
        procurementForm: [
          {
            required: true, message: '此处为必填项，不能为空。', trigger: 'change', type: 'number',
          },
        ],
      },
      purchasePlan: {
        code: '',
        status: '',
        createUserName: '',
        createTime: '',
        goodsType: null,
        goodsTypeName: '',
        type: '',
        expressType: '',
      },
      paymentType: ['普通', '寄售'],
      columns: [
        {
          title: '行号',
          minWidth: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '通用名称',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoApprovedDrugNames',
          render: (h, params) => {
            const purchaseMedicineHasExpiryLicense = params.row.purchaseMedicineHasExpiryLicense;
            const resStr = params.row.medicineInfoVoApprovedDrugNames;
            let isExpir = false;
            let resDiv;
            const expirIcon = h('img', {
              class: 'expir-icon',
              attrs: {
                src: Expire,
              },
            });
            if (purchaseMedicineHasExpiryLicense == 1) {
              isExpir = true;
            }
            if (isExpir) {
              resDiv = [expirIcon, resStr];
            } else {
              resDiv = resStr;
            }
            return h('div', {
              class: {
                'approve-goods-wrap': true,
              },

            }, resDiv);
          },
        },
        {
          title: '规格',
          tooltip: true,
          key: 'medicineInfoVoSpecifications',
          minWidth: 130,
        },
        {
          title: '生产企业',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoManufacturer',
        },
        {
          title: '上市许可持有人',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoMah',
        },
        {
          title: '仓库库存',
          tooltip: true,
          key: 'inventoryNum',
          minWidth: 82,
        },
        {
          title: '上月销量',
          tooltip: true,
          key: 'lastMonthSaleNum',
          minWidth: 82,
        },
        {
          title: '商品编码',
          tooltip: true,
          key: 'purchaseMedicineDrugSerialCode',
          minWidth: 82,
        },
        {
          title: '商品名',
          minWidth: 142,
          tooltip: true,
          key: 'purchaseMedicineGoodsName',
        },
        {
          title: '批准文号',
          minWidth: 116,
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
        },
        {
          title: '剂型',
          tooltip: true,
          key: 'medicineInfoVoDosageFormString',
          minWidth: 116,
        },
        {
          title: '产地',
          minWidth: 142,
          tooltip: true,
          key: 'countryOfOrigin',
        },
        {
          title: '在途数量',
          tooltip: true,
          key: 'onTheWayNum',
          minWidth: 116,
        },
        {
          title: '计划数量',
          minWidth: 90,
          fixed: 'right',
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.onMountInput(params.index, value);
              },
            },
            props: {
              value: params.row.purchaseMedicineNum,
              min: 0,
              precision: 2,
              ifNeedCheckAllNumber: true,
              frontDecimal: 7,
            },
          }),
        },
        {
          title: '计划单价',
          minWidth: 112,
          fixed: 'right',
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.onPriceInput(params.index, value);
              },
            },
            props: {
              value: params.row.purchaseMedicinePlanPrice,
              min: 0,
              precision: 6,
            },
          }),
        },
        {
          title: '供应商',
          fixed: 'right',
          minWidth: 172,
          render: (h, params) => h(SupplierListSelect, {
            props: {
              value: params.row.purchaseMedicineSupplierId,
              status: 1,
              purchaseType: this.purchasePlan.type,
            },
            on: {
              'on-change': (value, selectedItem) => {
                this.onChangeSupplier(params.index, value, selectedItem);
              },
            },
          })
          ,
        },
        {
          title: '款期',
          fixed: 'right',
          minWidth: 100,
          render: (h, params) => {
            const optionArr = [
              h('option', {
                domProps: {
                  value: 1,
                },
              }, '预付'),
              h('option', {
                domProps: {
                  value: 2,
                },
              }, '现款'),
              h('option', {
                domProps: {
                  value: 3,
                },
              }, '7天'),
              h('option', {
                domProps: {
                  value: 4,
                },
              }, '15天'),
              h('option', {
                domProps: {
                  value: 5,
                },
              }, '30天'),
              h('option', {
                domProps: {
                  value: 6,
                },
              }, '45天'),
              h('option', {
                domProps: {
                  value: 7,
                },
              }, '60天'),
              h('option', {
                domProps: {
                  value: 8,
                },
              }, '90天'),
              h('option', {
                domProps: {
                  value: 9,
                },
              }, '压批'),
              h('option', {
                domProps: {
                  value: 10,
                },
              }, '实销实结'),
            ];
            return h('select',
              {
                class: {
                  'dtp-select': true,
                },
                domProps: {
                  value: params.row.purchaseMedicinePaymentPeriod,
                },
                on: {
                  change: (e) => {
                    this.tableData[params.index].purchaseMedicinePaymentPeriod = e.target.value;
                  },
                },
              }, optionArr);
          },
        },
        {
          title: '成本类型',
          fixed: 'right',
          minWidth: 90,
          render: (h, params) => {
            const optionArr = [
              h('option', {
                domProps: {
                  value: 1,
                },
              }, '普通'),
              h('option', {
                domProps: {
                  value: 2,
                },
              }, '寄售'),
            ];
            return h('select',
              {
                class: {
                  'dtp-select': true,
                },
                domProps: {
                  value: params.row.purchaseMedicinePayment,
                },
                on: {
                  change: (e) => {
                    this.tableData[params.index].purchaseMedicinePayment = e.target.value;
                  },
                },
              }, optionArr);
          },
        },
        {
          title: '操作',
          fixed: 'right',
          width: 72,
          render: (h, params) => h('lk-button',
            {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.onDelete(params.index);
                },
              },

            }, '删除'),
        },
      ],
      tableData: [],
      page: 1,
      size: 10,
      count: 0,
      expirColumns: [
        {
          title: '通用名称',
          minWidth: 116,
          key: 'medicineInfoVoApprovedDrugNames',
        },
        {
          title: '药品注册批件',
          minWidth: 116,
          key: 'purchaseMedicineDrugRegApprovalExpiry',
          render: (h, params) => {
            const purchaseMedicineDrugRegApprovalExpiry = params.row.purchaseMedicineDrugRegApprovalExpiry;
            let resStr = '-';
            let isExpir = false;
            if (purchaseMedicineDrugRegApprovalExpiry) {
              resStr = utils.formatTime(purchaseMedicineDrugRegApprovalExpiry, 'YYYY/MM/DD');
            }
            if (params.row.purchaseMedicineIsDrugRegApprovalExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: '进口注册证',
          minWidth: 116,
          key: 'purchaseMedicineImportRegCertExpiry',
          render: (h, params) => {
            const purchaseMedicineImportRegCertExpiry = params.row.purchaseMedicineImportRegCertExpiry;
            let resStr = '-';
            let isExpir = false;
            if (purchaseMedicineImportRegCertExpiry) {
              resStr = utils.formatTime(purchaseMedicineImportRegCertExpiry, 'YYYY/MM/DD');
            }
            if (params.row.purchaseMedicineIsImportRegCertExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: '生产许可证',
          minWidth: 116,
          key: 'purchaseMedicineProdLicenseExpiry',
          render: (h, params) => {
            const purchaseMedicineProdLicenseExpiry = params.row.purchaseMedicineProdLicenseExpiry;
            let resStr = '-';
            let isExpir = false;
            if (purchaseMedicineProdLicenseExpiry) {
              resStr = utils.formatTime(purchaseMedicineProdLicenseExpiry, 'YYYY/MM/DD');
            }
            if (params.row.purchaseMedicineIsProdLicenseExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: 'GMP证书',
          minWidth: 116,
          key: 'purchaseMedicineGmpCertExpiry',
          render: (h, params) => {
            const purchaseMedicineGmpCertExpiry = params.row.purchaseMedicineGmpCertExpiry;
            let resStr = '-';
            let isExpir = false;
            if (purchaseMedicineGmpCertExpiry) {
              resStr = utils.formatTime(purchaseMedicineGmpCertExpiry, 'YYYY/MM/DD');
            }
            if (params.row.purchaseMedicineIsGmpCertExpiry == 1) {
              isExpir = true;
            }
            return h('span', {
              class: {
                'orange-words': isExpir,
              },
            }, resStr);
          },
        },
        {
          title: '备注',
          minWidth: 116,
          key: 'purchaseMedicineExpiryRemark',
          render: (h, params) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.onExpiryRemarkBlur(e, params.row);
              },
            },
            props: {
              value: params.row.purchaseMedicineExpiryRemark,
              maxlength: 100,
            },
          }),
        },
      ],
    };
  },
  watch: {
    tableData: {
      handler() {
        this.handleInputRegister();
      },
    },
    'purchasePlan.goodsType': {
      handler() {
        // 切换文案
        if (this.purchasePlan.goodsType === 2) {
          this.purchasePlan.expressType = null;
          this.columns.splice(9, 1, {
            title: '注册证号/备案号',
            minWidth: 124,
            tooltip: true,
            key: 'approvalNumber',
          });
          this.expressStatus = false;
        } else if (this.purchasePlan.goodsType === 1) {
          this.expressStatus = true;
        } else {
          this.expressStatus = false;
          this.purchasePlan.expressType = null;
          this.columns.splice(9, 1, {
            title: '批准文号',
            minWidth: 116,
            tooltip: true,
            key: 'approvalNumber',
          });
        }
      },
    },
  },
  methods: {
    attachmentConfirm(val) {
      this.uploadInfo = val;
    },
    hotkeysRegister() {
      hotkeys('alt+f1,option+fn+f1', () => {
        this.$refs.goods0.focus();
      });
    },
    handleInputRegister() {
      this.$nextTick(() => {
        const allInput = document.querySelectorAll('.ivu-table-cell:not(.ivu-table-hidden)  input:not([type=checkbox])');
        allInput.forEach((item, index) => {
          item.onkeydown = (e) => {
            if (e.key === 'Enter') {
              let nextIndex = index + 1;
              if (nextIndex >= allInput.length) {
                nextIndex = 0;
              }
              const nextEl = allInput[nextIndex];
              nextEl.focus();
            }
            if (e.altKey && e.key === 'F1') {
              this.$refs.goods0.focus();
            }
          };
        });
      });
    },
    onResetModelOk() {
      this.getData().then(() => {
        this.closeLeavelModal();
      }).catch((err) => {
        utils.handleError(err);
      });
      this.resetModelShow = false;
    },
    closeLeavelModal() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          this.$store.commit('setLeaveModal', false);
          resolve();
        });
      });
    },
    onTypeModelOk() {
      this.tableData = [];
      this.typeModelShow = false;
      this.setBack();
    },
    onTypeModelCancel() {
      this.useBack();
    },
    onGoodsTypeChange() {
      console.log('onGoodsTypeChange');
      this.showTypeModal('GoodsType');
      // 如果是中药饮片，那么来源只能是普通商品
      if (this.purchasePlan.goodsType == 3) {
        this.purchasePlan.type = 2;
      }
      // 如果没有显示弹窗，直接更新
      if (!this.typeModelShow) {
        this.setBack();
      }
    },
    onGoodsOriginChange() {
      console.log('onGoodsOriginChange');
      this.showTypeModal('GoodsOrigin');
      // 如果没有显示弹窗，直接更新
      if (!this.typeModelShow) {
        this.setBack();
      }
    },
    setBack() {
      this.backGoodsType = this.purchasePlan.goodsType;
      this.backOriginType = this.purchasePlan.type;
    },
    useBack() {
      this.purchasePlan.goodsType = this.backGoodsType;
      this.purchasePlan.type = this.backOriginType;
    },
    showTypeModal(flag) {
      // 如果有商品，弹出弹窗
      if (flag === 'GoodsType') {
        this.typeModalContent = '采购类型一旦变更，将清空商品信息。是否确定变更？';
      } else {
        this.typeModalContent = '采购来源一旦变更，将清空商品信息。是否确定变更？';
      }
      if (this.tableData.length > 0) {
        this.typeModelShow = true;
      }
    },
    onExpiryRemarkBlur(e, row) {
      const expiryRemark = e.target.value;
      this.tableData.forEach((item) => {
        if (item.purchaseMedicineMedicineId == row.purchaseMedicineMedicineId) {
          item.purchaseMedicineExpiryRemark = expiryRemark;
        }
      });
    },
    onLogCancel() {
      this.logShow = false;
    },
    onShowLog() {
      this.logShow = true;
    },
    onChangeSupplier(index, value, supplierObj) {
      const item = this.tableData[index];
      item.purchaseMedicineSupplierCode = supplierObj && supplierObj.code;
      item.purchaseMedicineSupplierName = supplierObj && supplierObj.name;
      item.purchaseMedicineSupplierId = value;
    },
    onMountInput(index, value) {
      const item = this.tableData[index];
      item.purchaseMedicineNum = value;
    },
    onPriceInput(index, value) {
      const item = this.tableData[index];
      item.purchaseMedicinePlanPrice = value;
    },
    onInputSelected(item) {
      console.log(item);
      item.supplierId = null; // 禁止自动带出供应商
      item.paymentPeriod = null; // 禁止带出款期默认值，每次都需要重新选择，防止选错提交
      let isExist = false;
      this.tableData.forEach((tableItem) => {
        if (item.medicineId === tableItem.medicineId) {
          isExist = true;
        }
      });
      if (!isExist) {
        const result = {
          purchaseMedicineNum: item.num,
          purchaseMedicinePlanPrice: item.planPrice,
          purchaseMedicineSupplierId: item.supplierId,
          purchaseMedicineSupplierName: item.supplierName,
          purchaseMedicineSupplierCode: item.supplierCode,
          purchaseMedicinePayment: item.payment,
          medicineInfoVoApprovedDrugNames: item.approvedDrugName,
          medicineInfoVoMah: item.mah,
          medicineInfoVoSpecifications: item.specification,
          inventoryNum: item.inventoryNum,
          lastMonthSaleNum: item.lastMonthSaleNum,
          purchaseMedicineDrugSerialCode: item.drugSerialCode,
          medicineInfoVoDosageFormString: item.dosageForm,
          onTheWayNum: item.onTheWayNum,
          purchaseMedicineMedicineId: item.medicineId,
          purchaseMedicineDrugMinimumPackagingUnit: item.drugMinimumPackagingUnit,
          purchaseMedicineCountryOfOrigin: item.countryOfOrigin,
          medicineInfoVoManufacturer: item.manufacturer,
          purchaseMedicineStorageCondition: item.storageCondition,
          purchaseMedicineGoodsName: item.goodsName,
          medicineInfoVoApprovalCode: item.approvalNumber,
          purchaseMedicineHasExpiryLicense: item.hasExpiryLicense,
          purchaseMedicineIsDrugRegApprovalExpiry: item.isDrugRegApprovalExpiry,
          purchaseMedicineDrugRegApprovalExpiry: item.drugRegApprovalExpiry,
          purchaseMedicineImportRegCertExpiry: item.importRegCertExpiry,
          purchaseMedicineIsImportRegCertExpiry: item.isImportRegCertExpiry,
          purchaseMedicineExpiryRemark: '',
        };
        if (this.purchasePlan.type === 2) {
          result.purchaseMedicinePlanPrice = 0;
        }
        if (this.tableData.length >= this.limitedNumer) {
          alert('单张单据不能超过100行明细，请拆分多次创建');
          return;
        }
        this.tableData.unshift(result);
      }
    },
    onBtnClick(name) {
      if (name === 'save') {
        this.onSave();
      } else if (name === 'cancel') {
        this.onCancel();
      } else if (name === 'reset') {
        this.onShowResetModal();
      } else if (name === 'log') {
        this.onShowLog();
      } else if (name === 'submit') {
        this.onSubmit();
      }
    },
    onShowResetModal() {
      this.resetModelShow = true;
    },
    onSave() {
      this.onAdd('save');
    },
    getLog() {
      const params = {
        purchasePlanId: this.$route.params.purchasePlanId,
      };
      this.$store.commit('setDisableLoading', true);
      purchase.planLog(params).then((res) => {
        if (res.data.status === 200) {
          let logItem = {};
          res.data.data.forEach((item) => {
            const time = utils.formatTime(item.createTime, 'YYYY/MM/DD HH:mm');
            if (item.type == 1) {
              logItem = {
                content: `${time}由${item.createUserName}创建`,
              };
            }
            if (item.type == 2) {
              let children = [];
              if (item.operateList.length) {
                children = item.operateList.map(modifyItem => ({
                  content: `${modifyItem.content},旧值: ${modifyItem.oldValue}, 新值: ${modifyItem.newValue}`,
                }));
              }
              logItem = {
                content: `${time}由${item.createUserName}修改`,
                children,
              };
            }
            if (item.type == 3) {
              let children = [];
              let status = '';

              if (item.operateList.length) {
                children = item.operateList.map((reviewItem) => {
                  const reviewTime = utils.formatTime(reviewItem.operateTime, 'YYYY/MM/DD HH:mm');
                  if (reviewItem.workStatus === 1) {
                    status = '通过';
                  } else if (reviewItem.workStatus === 2) {
                    status = '驳回';
                  }
                  return {
                    content: `${reviewTime},由${reviewItem.operateUserName}审批, 结果： ${status}，意见： ${reviewItem.idea || '无'}`,
                  };
                });
              }
              logItem = {
                content: `${time}由${item.createUserName}审批`,
                children,
              };
            }
            this.LogItems.push(logItem);
          });
        }
      });
    },
    onSubmit() {
      this.onAdd('submit');
    },
    onCancel() {
      this.tableData = [];
      this.closeLeavelModal().then(() => {
        this.$router.push({ name: 'plan' });
      });
    },
    onAdd(flag) {
      let addFunction;
      let noValidate = false;
      let noRemarkValidate = false;
      if (flag === 'save') {
        addFunction = purchase.planEditSave;
      } else {
        addFunction = purchase.planSubmit;
      }
      if (this.tableData.length <= 0) {
        this.$Message.warning('采购计划为空时无法保存，请至少选择一个商品');
        return;
      }
      const medicineArr = this.tableData.map(item => ({
        purchaseMedicine: {
          medicineId: item.purchaseMedicineMedicineId,
          payment: item.purchaseMedicinePayment,
          planPrice: item.purchaseMedicinePlanPrice,
          num: item.purchaseMedicineNum,
          supplierId: item.purchaseMedicineSupplierId,
          supplierName: item.purchaseMedicineSupplierName,
          supplierCode: item.purchaseMedicineSupplierCode,
          drugSerialCode: item.purchaseMedicineDrugSerialCode,
          approvedDrugName: item.medicineInfoVoApprovedDrugNames,
          specification: item.medicineInfoVoSpecifications,
          dosageForm: item.medicineInfoVoDosageFormString,
          drugMinimumPackagingUnit: item.purchaseMedicineDrugMinimumPackagingUnit,
          countryOfOrigin: item.purchaseMedicineCountryOfOrigin,
          manufacturer: item.medicineInfoVoManufacturer,
          storageCondition: item.purchaseMedicineStorageCondition,
          expiryRemark: item.purchaseMedicineExpiryRemark,
          hasExpiryLicense: item.purchaseMedicineHasExpiryLicense,
          paymentPeriod: item.purchaseMedicinePaymentPeriod,
        },
      }));
      medicineArr.forEach((item) => {
        const purchaseMedicine = item.purchaseMedicine;
        if (flag !== 'save') {
        // 判断单价不为空
          if (purchaseMedicine.planPrice === null) {
            noValidate = true;
          }
          if (!purchaseMedicine.num || !purchaseMedicine.supplierId || !purchaseMedicine.payment) {
            noValidate = true;
          }
          if (!purchaseMedicine.paymentPeriod) {
            noValidate = true;
          }
          if (!_.isNumber(purchaseMedicine.num) || !_.isNumber(purchaseMedicine.planPrice)) {
            noValidate = true;
          }
          if (purchaseMedicine.hasExpiryLicense == 1 && !purchaseMedicine.expiryRemark.trim()) {
            noRemarkValidate = true;
          }
        }
      });
      if (noRemarkValidate) {
        this.$Message.error('存在有效期已过期商品，需要添加过期备注才可提交。');
        return;
      }
      if (noValidate) {
        // 验证不通过
        this.$Message.error('请填写完整数据');
        return;
      }
      const data = {
        purchasePlan: {
          id: this.queryParams.purchasePlanId,
          type: this.purchasePlan.type,
          goodsType: this.purchasePlan.goodsType,
          expressType: this.purchasePlan.expressType,
        },
        bizExtraVos: this.uploadInfo.some(item => item.appendixName === '' || item.appendixUrl === '') ? [{}] : this.uploadInfo,
        purchaseMedicineInfoVoList: medicineArr,
      };
      addFunction(data).then((res) => {
        if (res.data.status === 200) {
          this.closeLeavelModal().then(() => {
            this.$router.push({ name: 'plan' });
          });
        } else {
          this.$Message.error(res.data.error);
        }
      });
    },
    onDelete(index) {
      this.tableData.splice(index, 1);
    },
    initItem(row, index) {
      this.editNum = row.purchaseMedicineNum;
      this.editSupplierID = row.purchaseMedicineSupplierId;
      this.editPrice = row.purchaseMedicinePlanPrice;
      this.editPayment = row.purchaseMedicinePayment;
      this.editIndex = index;
    },
    resetItem() {
      this.editNum = '';
      this.editSupplierID = '';
      this.editPrice = '';
      this.editPayment = '';
      this.editIndex = -1;
    },
    onEditSupplier(value) {
      this.editSupplierID = value;
    },
    getData() {
      return new Promise((resolve, reject) => {
        this.queryParams.purchasePlanId = this.$route.params.purchasePlanId;
        purchase.planInfo(this.queryParams).then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            const temp = res.data.data;
            this.uploadInfo = temp.bizExtraVos || [];
            this.purchasePlan.createTime = utils.formatDate(temp.purchasePlan.createTime);
            this.purchasePlan.createUserName = temp.purchasePlan.createUserName;
            this.purchasePlan.code = temp.purchasePlan.code;
            this.purchasePlan.status = temp.purchasePlan.status;
            this.purchasePlan.goodsType = temp.purchasePlan.goodsType;
            this.purchasePlan.typeName = temp.purchasePlan.typeName;
            this.purchasePlan.type = temp.purchasePlan.type;
            this.purchasePlan.procurementForm = temp.purchasePlan.procurementForm;
            this.backType = temp.purchasePlan.goodsType;
            this.purchasePlan.goodsTypeName = temp.purchasePlan.goodsTypeName;
            this.purchasePlan.expressType = temp.purchasePlan.expressType || '';
            temp.purchaseMedicineInfoVoList.forEach((item) => {
              const result = {};
              utils.exchangeTable(item, result);
              console.log(result);
              this.tableData.push(result);
            });
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          reject(err);
          utils.handleError(err);
        });
      });
    },
    handleChangeScan(val) {
      if (val === 1) {
        this.$refs.goods0.focus();
      }
    },
  },
  mounted() {
    this.expressTypeList1 = expressTypeList.expressTypeList;
    this.getNormalGoodsTypes = expressTypeList.getNormalGoodsTypes;
    this.procurementFormList = expressTypeList.procurementFormList;
    this.getData().then(() => {
      this.$watch('tableData', () => {
        this.$store.commit('setLeaveModal', true);
      }, { deep: true });
    }).catch((err) => {
      utils.handleError(err);
    });
    this.getLog();
    this.hotkeysRegister();
    this.$nextTick(() => {
      this.handleInputRegister();
    });
  },
};
</script>
<style lang="less">
.plan-edit{
  .plan-table-index{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .plan-table{
    margin-top: 10px;
  }
  .orange-words{
    color: #FF4D07;
  }
  .approve-goods-wrap{
    display: flex;
    img{
      margin-right:4px;
    }
  }
  .expir-card{
    margin-top: 12px;
  }
  .goods-card{
    margin-top:12px;
    .ivu-card-body{
      position: relative;
    }
  }
  .sum-wrap{
    position: absolute;
    top: 8px;
    right: 0;
    width: 226px;
    height: 42px;
    left: auto;
    .title-amount{
      font-size: 12px;
      color: rgba(46,46,46,0.65);
      position: absolute;
      left: 0;
      top: 0;
      line-height: 18px;
    }
    .content-amount{
      font-size: 18px;
      color: rgba(46,46,46,0.85);
      bottom: 0;
      left: 0;
      position: absolute;
    }
    .title-money{
      font-size: 12px;
      color: rgba(46,46,46,0.65);
      position: absolute;
      top: 0;
      left: 90px;
      line-height: 18px;
    }
    .content-money{
      font-size: 18px;
      color: rgba(46,46,46,0.85);
      bottom: 0;
      left: 90px;
      position: absolute;
    }
  }
  .goods-add-wrap{
    display: flex;
    align-items: center;
    label{
      font-size:12px;
      height:17px;
      line-height:17px;
      font-weight:bold;
      margin-right:4px;
    }
  }

}

</style>
